import { createSlice } from "@reduxjs/toolkit";
import resetPasswordApi from "../../../rtk-apis/authentication/resetPassword";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: "",
};

const resetPasswordSlice = createSlice({
    name: "resetPasswordSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(resetPasswordApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(resetPasswordApi.fulfilled, (state, { payload }) => {
                console.log('payload', payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(resetPasswordApi.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default resetPasswordSlice.reducer;
